import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

interface Swatch {
  swatchId: string;
  status?: string;
  type?: string;
  swatchImageLg?: { url: string };
  swatchGroupName?: string;
}

export const selectedSwatchAtom = atom<Swatch>();
export const useSelectedSwatchAtom = () => useAtom(selectedSwatchAtom);
export const useSetSelectedSwatchAtom = () => useSetAtom(selectedSwatchAtom);
export const useSelectedSwatchAtomValue = () =>
  useAtomValue(selectedSwatchAtom);
